// 所有的碎片数据，包括动画
function formateData (source, type) {
  const target = []
  let size = window.innerWidth / 375 * 370
  if (location.search.indexOf('test') > 0) {
    size = 1080
  }
  if (type) {
    size = size * 0.5
  }

  source.split('\n').forEach(line => {
    if (!line || line.trim().length <= 0) return false
    line = line.replace(/^\s*\d+\.?\s?/ig, '')
    let color = line.match(/^#\w{6}/ig)[0]
  
    const points = line.replace(/^#\w{6}\s+/ig, '').replace(/\s+/ig, '-').split('-')
  
    let point1 = {
      x: (points[0].split(',')[0] - 0) / 2160 * size,
      y: (points[0].split(',')[1] - 0) / 2160 * size
    }
    let point2 = {
      x: (points[1].split(',')[0] - 0) / 2160 * size,
      y: (points[1].split(',')[1] - 0) / 2160 * size
    }
    let point3 = {
      x: (points[2].split(',')[0] - 0) / 2160 * size,
      y: (points[2].split(',')[1] - 0) / 2160 * size
    }
  
    target.push({
      color,
      point1,
      point2,
      point3
    })
  })

  return target
}


// 默认状态
// const defalutPiece = {
//   pieces: formateData(`
//   1.#000000    1080,1080     1080,1080     1080,1080
//   3.#000000    1080,1080     1080,1080     1080,1080
//   4.#000000    1080,1080     1080,1080     1080,1080
//   7.#000000    1080,1080     1080,1080     1080,1080
//   8.#000000    1080,1080     1080,1080     1080,1080
//   5.#000000    1080,1080     1080,1080     1080,1080
//   9.#000000    1080,1080     1080,1080     1080,1080
//   2.#000000    1080,1080     1080,1080     1080,1080
//   6.#000000    1080,1080     1080,1080     1080,1080
//   10.#000000    1080,1080     1080,1080     1080,1080
//   11.#000000    1080,1080     1080,1080     1080,1080
//   12.#000000    1080,1080     1080,1080     1080,1080
//   13.#000000    1080,1080     1080,1080     1080,1080
//   14.#000000    1080,1080     1080,1080     1080,1080
//   15.#000000    1080,1080     1080,1080     1080,1080
//   16.#000000    1080,1080     1080,1080     1080,1080
//   17.#000000    1080,1080     1080,1080     1080,1080
//   30.#000000    1080,1080     1080,1080     1080,1080
//   29.#000000    1080,1080     1080,1080     1080,1080
//   28.#000000    1080,1080     1080,1080     1080,1080
//   24.#000000    1080,1080     1080,1080     1080,1080
//   25.#000000    1080,1080     1080,1080     1080,1080
//   27.#000000    1080,1080     1080,1080     1080,1080
//   26.#000000    1080,1080     1080,1080     1080,1080
//   18.#000000    1080,1080     1080,1080     1080,1080
//   19.#000000    1080,1080     1080,1080     1080,1080
//   20.#000000    1080,1080     1080,1080     1080,1080
//   21.#000000    1080,1080     1080,1080     1080,1080
//   22.#000000    1080,1080     1080,1080     1080,1080
//   23.#000000    1080,1080     1080,1080     1080,1080
//   `),
//   dragPiece: {
//     index: -1,
//     x: 0,
//     y: 0
//   }
// }

const defalutPiece = {
  bg: '',
  pieces: formateData(`
  1.#fce9d8                 663,1319            1139,1417              565,1560
  2.#fff338                  1605,495            1571,611               1407,571
  3.#fa703b                2361,571             2569,1469             2237,847
  4.#df4456                3037,1059          3209,1209             3049,1357
  5.#e4f3a9               3739,931            3965,1057             3665,1157
  6.#fff898                  4231,2355          4199,2471             4029,2429
  7.#bee2cb               2871,3657          3103,3761             3007,3839
  8.#fff780                  1771,3855          1903,4035             1771,4031
  9.#fbc074                428,3283            1074,3177              460,3423
  10.#fec283              618,1933            716,2375                544,2115
  11.#cfea64               861,2033            1473,1601              1181,2087
  12.#e16a6c              1953,1401           2499,1541              2431,2251
  13.#fec731              2636,1571           2732,1805              2414,2055
  14.#dce8ff              3205,1733           3319,2015              3093,1943
  15.#0091ff              3497,1959           3555,2103              3407,2225
  16.#65e7ff            3383,2863           3381,3063              3101,3139
  17.#fff779               2373,3139           2549,3325              2259,3215
  18.#a0d9fc             1921,3053           1955,3351              1835,3221
  19.#6baeff             1263,2631            2107,2179             1635,2629
  20.#ffba6b            1503,2229           1451,2575             1243,2363
  21.#6dd400            1485,1879           1771,2031             1515,2007 
  22.#fa703b             1897,2033           2059,2033              2005,2233
  23.#cceb53              2693,2147           3015,2287             2721,2375
  24.#ffad2b              3407,2547           3129,2987             2291,2691
  25.#df4456             2254,2253           2254,2833             1956,2937
  26.#ea6969             1068,2570           951,2857              876,2740
  27.#df4456             1764,1374           1612,1475             1561,1317
  28.#44d7b6             2312,1731           1937,1832             1813,1672
  29.#acebff             1486,3366           1411,3443             1368,3282
  30.#d98cef             3868,3628           3837,3748             3662,3706
  `, 'type'),
  dragPiece: {
    index: -1,
    x: 0,
    y: 0
  },
  animate: []
}



// 科技 VR眼镜
const science = {
  bg: 'bg_science',
  keyword: '创新驱动',
  quotoText: '坚持创新在我国现代化建设全局中的核心地位，把科技自立自强作为国家发展的战略支撑\n全社会研发经费投入年均增长7%以上\n每万人口高价值发明专利拥有量提高到12件\n数字经济核心产业增加值占GDP比重提高到10%\n支持北京、上海、粤港澳大湾区形成国际科创中心'.split('\n'),
  head: 'science.jpg',
  audio: 'science.mp3',
  title: '全国人大代表 王建宇',
  title2: '全国人大代表、中国科学院院士 王建宇',
  desc: '科技创新是民族发展的“灵魂”',
  text: '十九届五中全会以后国家把科技强国这件事情提高到有史以来最高的位置上。作为科技工作者压力和使命感还是很强的。科技的面非常广，中国又是一个大国，中国可以说参与到科技活动的人员是世界上最多的，中国现在在科技上的投入已经达到了世界第二。在“十四五”时期，我们必须执行一个有限目标，合理的选好对中国发展有益的方向和领域进行突破。\n创新的理念是最根本的。所谓科技就是生产力，领先发展的东西就是科技，没有创新谈何发展。一个国家、一个民族创新的文化和创新的思想，才是民族发展的“灵魂”。\n量子和航天是中国目前做的比较好、比较擅长，我建议国家应该给予继续支持，一个领域超越别人非常辛苦，但是被超越却很容易。在“十四五”规划中，我们可以通过树立有限目标争取让更多的科学研究方向和领域能够走到国际领跑的水平。'.split('\n'),
  pieces: formateData(`
  1.#f1f8ff             601,883            596,1021             561,1051
  2.#f1f8ff             561,1051          596,1080             596,1217
  3.#d9e8f6           601,883            780,869               597,1021
  4.#dcebf9           780,869            877,1051             561,1051
  5.#cfe1f1             561,1051          877,1051             798,1237
  6.#dcebf9            595,1078          798,1237             596,1217
  25.#fce9d8           1269,1041         1458,1350        824,1204
  7.#b6ccdf            877,1051          1011,1063           798,1237
  8.#a7bccd           1011,1063         979,1207            798,1237
  9.#d2e3f3           780,869            1011,1063           877,1051
  10.#b0c5d7         780,869           1011,927             1011,1063
  13.#e89970         1056,582          1383,628             875,698
  12.#d2794a          875,698           1383,628            780,868
  11.#fce9d8      1041,763         1269,993             779,869
  30.#eabf9b           894,1220           950,1510           798,1237

  28.#eabf9b           1458,1350         1117,1578        1048,1437
  27.#fce9d8           1458,1350         1567,1578         1117,1578

  29.#eacaae           894,1220           1458,1350         950,1510
  14.#b96438         1383,628          1269,1041          1041,763
  15.#965330         1383,628          1458,1350          1269,1041
  16.#7c3f20           1383,628          1566,968           1458,1350
  24.#252525          1012,928           1224,926          992,1142
  22.#000000          1450,975           1425,1080        1269,1041
  23.#111111          1224,926           1450,975          992,1142
  26.#b96438          1269,1041         1335,1144        1267,1195
  17.#713313          1383,628          1522,772           1566,968
  20.#485969          1440,1020         1545,1142        1410,1093
  21.#9ab4cb          1440,957           1566,968          1440,1020
  18.#485969          1566,968          1596,1048         1440,1020
  19.#2c3b49          1596,1048         1545,1142        1440,1020
  `),
  dragPiece: {
    index: 23,
    x: window.innerWidth / 750 * (-30),
    y: window.innerWidth / 750 * 380
  },
  animate: []
}


// 通信5G
const i5G = {
  bg: 'bg_communication',
  keyword: '“新基建”',
  quotoText: '加快5G网络规模化部署，用户普及率提高到56%，推广升级千兆光纤网络\n实施中西部地区中小城市基础网络完善工程\n建设商业航天发射场\n加快交通、能源、市政等传统基础设施数字化改造'.split('\n'),
  head: '5g.jpg',
  title: '全国政协委员 张云勇',
  title2: '全国政协委员、中国联通集团产品中心总经理 张云勇 ',
  desc: '5G建设要适度超前：“先修路，来等车” 才能有产业数字化',
  audio: '5g.mp3',
  text: '5G建设一定要适度超前。如果把5G比喻成路，其他实体经济、共享经济比喻成车的话，那我们要“先修路，来等车”。站在全局的角度来讲，这是可为的，也是必为的。因为只有把5G新基建做好，数字产业化做好之后，才能有产业数字化。\n光修好路，车不一定跑得好，还得有序地去调度、去匹配，什么路跑什么车。5G的应用千行百业，小企业想用运营商的，但是没钱；大企业开始自己干，但平台、数据就会割裂，数据价值密度低，整个数字经济协同作用就很难发挥出来，数字红利就很难实现。大家都需要朝前挪半步，互相换位思考。\n新基建归根到底是为了做数据流通，相关的产权配置体系应区分国家数据、行业数据、企业数据、个人数据，依场景制定相应的数据权属、使用、交易、共享机制，保证个人隐私的同时，保证一定程度的合法的数据流通，这样我们才能构建智慧型政府，让数据多跑腿，群众少跑路、不跑路。'.split('\n'),
  pieces: formateData(`
  1.#0d0d24    546,532     990,532     506,791
  3.#2a7bae     683,696     652,933     506,790
  4.#45cfff       506,790     652,933     479,964
  7.#feead1     403,1097   543,1098    626,1242
  8.#ffc79a      403,1097   626,1242    430,1213
  5.#042c54     667,817     841,829     652,933
  9.#ffba6b     430,1213   733,1258    576,1366
  2.#042c54     990,532     990,698     682,696
  6.#3c9ad5     841,829     986,950     651,933
  10.#ff9944   827,1192   772,1380    575,1366
  11.#ff9151   850,1114   932,1277    773,1379
  12.#ff6547   760,940     1191,1329  932,1277
  13.#ff9151   760,939     986,951      1062,1213
  14.#ff7c30   947,818     986,950      916,892
  15.#ff9944   1097,677   1026,1088  947,818
  16.#ffba6b   1307,622   1049,955    1097,676
  17.#ffc79a    1307,621   1307,815    1107,878
  30.#ff7c30     932,1277    1375,1367   965,1348
  29.#6f3743    965,1348    1375,1367   1163,1484
  28.#3c9ad5   1514,1290  1426,1492   1163,1484
  24.#0d0d24  1375,979   1755,979    1375,1146
  25.#042b51  1755,979   1755,1146   1375,1146
  27.#2a7bae   1575,1146  1625,1389  1426,1492
  26.#09417a  1575,1146  1755,1146   1625,1389

  18.#feead1   1374,917   1374,917    1374,917
  19.#ffba6b   1374,917   1374,917    1374,917

  20.#ffba6b   1514,916   1514,916    1514,916
  21.#ff6547   1514,916   1514,916    1514,916

  22.#45cfff    1648,916   1648,916    1648,916
  23.#2a7bae  1648,916   1648,916    1648,916
  `),
  dragPiece: {
    index: 0,
    x: window.innerWidth / 750 * 125,
    y: window.innerWidth / 750 * 520
  },
  animate: [{
    pieces: [
      // 18, 19
      {index: 24, piece: formateData('#feead1   1374,778   1482,778    1374,917')[0]},
      {index: 25, piece: formateData('#ffba6b   1482,778   1482,916    1374,917')[0]}
    ],
    delay: 0,
    duration: 300
  }, {
    pieces: [
      {index: 26, piece: formateData('#ffba6b   1514,676   1622,676    1514,916')[0]},
      {index: 27, piece: formateData('#ff6547   1622,676   1622,916    1514,916')[0]}
    ],
    delay: 0,
    duration: 300
  }, {
    pieces: [
      {index: 28, piece: formateData('#45cfff    1648,532   1755,532    1648,916')[0]},
      {index: 29, piece: formateData('#2a7bae  1755,532   1755,916    1648,916')[0]}
    ],
    delay: 0,
    duration: 300
  }, {
    pieces: [
      {index: 24, piece: formateData('#feead1   1374,917   1374,917    1374,917')[0]},
      {index: 25, piece: formateData('#ffba6b   1374,917   1374,917    1374,917')[0]},
      {index: 26, piece: formateData('#ffba6b   1514,916   1514,916    1514,916')[0]},
      {index: 27, piece: formateData('#ff6547   1514,916   1514,916    1514,916')[0]},
      {index: 28, piece: formateData('#45cfff    1648,916   1648,916    1648,916')[0]},
      {index: 29, piece: formateData('#2a7bae  1648,916   1648,916    1648,916')[0]}
    ],
    delay: 1000,
    duration: 300
  }, {
    pieces: [],
    delay: 2000,
    duration: 0
  }]
}

// 交通，高铁
const train = {
  bg: 'bg_traffic',
  keyword: '交通运输',
  quotoText: '建设现代化综合交通运输体系\n加快建设世界级港口群和机场群\n新增城际铁路和市域（郊）铁路运营里程3000公里\n新改建高速公路里程2.5万公里\n新增民用运输机场30个以上\n推进120个左右国家物流枢纽建设'.split('\n'),
  head: 'traffic.jpg',
  title: '全国人大代表 王艳',
  title2: '全国人大代表、天津市公交集团8路驾驶员 王艳',
  desc: '“人民交通为人民”，以新理念引领交通高质量发展',
  audio: 'traffic.mp3',
  text: '我们现在比较崇尚的这个现代化的综合交通体系，要更加安全，更加便捷，更加高效，更加绿色，更加经济。对于“十四五”，对于远景目标，我们都非常期待。\n“人民交通为人民”，也要充分以人民为中心。我们现在努力打造轨道上的京津冀，未来将持续贯彻新发展理念，完善城市快速路网架的梳理。因为京津冀迈向世界级的城市群，对于经济的拉动也是非常有意义的。\n现在天津和滨海新区不也叫“津城”“滨城”吗？我们的目标也是双城核心区能够20分钟直达，这样让上班族受益良多。也是希望能够强化补齐城市交通设施的短板，交通也要高质量的发展，绿色的发展。'.split('\n'),
  pieces: formateData(`
  12 #0B3C75 1905,1168 590,1455 237,1330
  18 #D2E6FF 385,1052 386,1190 329,1190
  17 #86B9F7 329,1190 386,1190 430,1312
  20 #F0F7FF 480,955 649,1052 385,1052
  19 #C7E0FF 385,1052 649,1052 386,1190
  30 #94C4FF 649,1052 610,1190 386,1190
  29 #266DC3 610,1190 610,1339 386,1190
  16 #2C79D7 386,1190 610,1339 430,1312
  22 #EEF6FF 712,779 737,955 480,955
  21 #E6F1FF 480,955 737,955 649,1052
  1 #BDDAFF 1071,702 977,774 712,779
  23 #FBFDFF 712,779 977,774 737,955
  2 #6BAEFF 1071,702 898,907 737,955
  24 #54A2FF 737,955 898,907 649,1052
  25 #6BAEFF 898,907 757,1091 649,1052
  27 #1E72D7 649,1052 757,1091 610,1190
  28 #125BB3 757,1091 610,1339 610,1190
  15 #0D50A0 757,1091 865,1312 610,1339
  3 #C7E0FF 1071,702 1242,762 898,907
  4 #E0EEFF 1242,762 1283,1092 898,907
  26 #D1E6FF 898,907 1283,1092 757,1091
  14 #154A8B 1283,1092 865,1312 757,1091
  5 #EBF4FF 1242,762 1709,969 1283,1092
  13 #0A3261 1283,1092 1506,1225 865,1312
  6 #D1E6FF 1709,969 1695,1121 1283,1092
  11 #154A8B 1695,1121 1506,1225 1283,1092
  7 #DCE6FF 1709,969 1991,1093 1695,1121
  8 #C8E1FF 1991,1093 2017,1145 1695,1121
  9 #154A8B 1695,1121 2017,1145 1905,1168
  10 #0A3261 1695,1121 1905,1168 1506,1225
  `),
  dragPiece: {
    index: 3,
    x: window.innerWidth / 750 * 175,
    y: window.innerWidth / 750 * 400
  },
  animate: [{
    pieces: [
      // 18, 27
      {index: 1, piece: formateData('#FFFFFF 385,1052 386,1190 329,1190')[0]},
      {index: 15, piece: formateData('#FFFFFF 649,1052 757,1091 610,1190')[0]}
    ],
    delay: 500,
    duration: 800
  }, {
    pieces: [
      {index: 1, piece: formateData('#D2E6FF 385,1052 386,1190 329,1190')[0]},
      {index: 15, piece: formateData('#1E72D7 649,1052 757,1091 610,1190')[0]}
    ],
    delay: 0,
    duration: 800
  }, {
    pieces: [
      {index: 1, piece: formateData('#FFFFFF 385,1052 386,1190 329,1190')[0]},
      {index: 15, piece: formateData('#FFFFFF 649,1052 757,1091 610,1190')[0]}
    ],
    delay: 0,
    duration: 800
  }, {
    pieces: [
      {index: 1, piece: formateData('#D2E6FF 385,1052 386,1190 329,1190')[0]},
      {index: 15, piece: formateData('#1E72D7 649,1052 757,1091 610,1190')[0]}
    ],
    delay: 0,
    duration: 800
  }, {
    pieces: [
      {index: 1, piece: formateData('#FFFFFF 385,1052 386,1190 329,1190')[0]},
      {index: 15, piece: formateData('#FFFFFF 649,1052 757,1091 610,1190')[0]}
    ],
    delay: 0,
    duration: 800
  }, {
    pieces: [],
    delay: 2000,
    duration: 0
  }]
}


// 消费
const shopping = {
  bg: 'bg_shopping',
  keyword: '消费',
  quotoText: '全面促进消费\n促进消费向绿色、健康、安全发展，稳步提高居民消费水平\n扩大节假日消费，完善节假日制度，全面落实带薪休假制度\n规划建设一批中国特色市内免税店'.split('\n'),
  head: 'shopping.jpg',
  audio: 'shopping.mp3',
  title: '全国人大代表 黄茂兴',
  title2: '全国人大代表、福建师范大学经济学院院长 黄茂兴',
  desc: '全面促进消费是推动中国和世界经济发展的重要动力',
  text: '消费是我们国家经济增长的重要引擎，也是经济稳定运行的“压舱石”。十九届五中全会提到全面促进消费，这是保障我国经济高质量发展的一个非常重要的政策安排。\n从过去这些年来看，消费对国民经济增长的贡献越来越大，我们作为一个有14亿人口的国家，是超大规模的消费市场。全面促进消费，是保障经济发展的一个很重要的驱动力，也就是经济实现高质量发展轨道的一种驱动力。\n2020年突如其来的新冠肺炎疫情，对我们国家的经济，包括对全球经济造成很大的影响。现在世界经济实际上有复苏，但是复苏是很脆弱的。2020年，我们国家是全球主要经济体当中唯一一个实现正增长的国家。从激发动力这个层面上说，全面促进消费不仅是激发中国经济发展的动力，同时也是推动世界经济缓慢复苏的一个很重要的动力。'.split('\n'),
  pieces: formateData(`
  9.#b8e1ff               1039,597            1393,649               879,596
  10.#9cd1fa             1393,649            1249,665              879,596
  11.#78aad0            879,596              1249,665              1248,835
  12.#679ec7            879,596              1248,835               879,760
  15.#293e65           1249,665             1393,930              1248,999 
  16.#466991           1249,665             1395,649              1393,930

  1.#b4362e              585,775             1023,1054            602,919
  2.#ce443a               585,775             1023,869              1023,1054
  3.#ff8e82                585,775             778,739                1023,869
  4.#e36a5e               778,739             1248,834              1023,869
  13.#791e17           1023,869             1248,835               1023,1054
  14.#641914           1248,835             1248,999              1023,1054
  
  5.#ffc69f                 713,585             713,791                 952,591
  6.#ffb785                952,591             945,835                 713,791 
  7.#b66847              952,591             1083,802               945,835
  8.#f6ae7d               952,591             1075,591               1083,802
  
  17.#b4362c           1395,739             1574,756              1395,776
  18.#939d9e           1574,759             1518,872              1447,886
  30.#e2edf3             642,935              864,1004              680,1230
  29.#cedae1            864,1004             864,1300              680,1230
  19.#b8c7d0           1518,872             864,1004              864,1300
  20.#abb6bc           1518,872             1447,1245            864,1300

  21.#abb6bc           1409,1246           1447,1245            1443,1442
  22.#212121           1443,1442           1299,1494            1299,1471
  23.#abb6bc            922,1529            1443,1442            922,1551
  24.#212121            922,1551            1066,1520            922,1577  
  25.#7d7d7d           1143,1274           1175,1271           1170,1397
  26.#222324            1048,1412          1170,1397            1048,1431
  27.#7d7d7d           735,1429             1170,1397            734,1452
  28.#222324            734,1452             867,1435             735,1472
  `),
  dragPiece: {
    index: 5,
    x: window.innerWidth / 750 * (-80),
    y: window.innerWidth / 750 * 480
  },
  animate: []
}



// 乡村振兴，拖缆机，农业建设
const tractor = {
  bg: 'bg_village',
  keyword: '乡村振兴',
  quotoText: '坚持农业农村优先发展，全面推进乡村振兴\n严守18亿亩耕地红线\n建成10.75亿亩集中连片高标准农田\n确保种源安全\n持续改善村容村貌和人居环境，建设美丽宜居乡村\n建立完善农村低收入人口和欠发达地区帮扶机制'.split('\n'),
  head: 'country.jpg',
  audio: 'country.mp3',
  title: '全国人大代表 余绍容',
  title2: '全国人大代表、四川省五星村党支部书记村委会主任 余绍容',
  desc: '坚持二十字方针 稳扎实干推进乡村振兴战略',
  text: '乡村振兴始终要坚持二十字方针的总体目标要求，就是产业兴旺、生态宜居、乡风文明、治理有效、生活富裕。在追求幸福生活的过程中，要把群众的短期利益作为奋斗的动力，要把长期的利益作为发展的保障。同时，乡村振兴离不开人才，人才才是创新的力量。乡村振兴离不开有经验有文化的年轻人，我们就要建立一个绿色的通道，来扶持他们来吸引他们回来。乡村振兴更是一项长期奋斗的工作，不要“一口吃成个大胖子”。要从一个方面入手，一步一步地走稳走实，打好群众思想和环境基础，逐步实现乡村振兴。'.split('\n'),
  pieces: formateData(`
  1.#e36a5e            1169,692             1217,719             736,658
  2.#ce443a             736,658               1217,719              707,719
  3.#0e7bd1            732,719               926,718              657,1026
  4.#1aa0dc             926,718              925,1024            657,1026
  5.#26c5f6              926,718             1197,1103           925,1024
  6.#65e7ff              926,718              1161,719            1197,1103

  8.#434343            654,1033            792,1282             512,1272
  9.#4b4b4b           512,1272            792,1282             651,1516
  10.#313131          792,1282            929,1518             651,1516
  11.#4b4b4b         792,1282            1069,1280           929,1518 
  12.#313131          934,1032           1069,1280           792,1282
  13.#272727          652,1033            934,1032            792,1282

  17.#343434          1325,1161          1430,1343          1222,1335
  18.#434343          1222,1335          1430,1343          1321,1515
  19.#313131          1430,1343          1527,1519          1321,1515
  20.#4b4b4b         1430,1343           1633,1343          1527,1518
  21.#272727          1530,1167          1633,1343          1430,1343
  22.#404040          1325,1161          1530,1167          1430,1343

  7.#ce443a             627,1026            925,1024            460,1228
  14.#4f0000           925,1024            926,1216            703,1120
  15.#791e17          925,1024            1644,1231          925,1218
  16.#4f0000           1036,1219          1287,1225          1069,1281
  23.#ce443a           1287,1225          1643,1231          1651,1293
  24.#ce443a           1625,1130          1654,1132          1651,1293
  25.#ce443a           1185,959            1643,1231          1196,1102
  26.#e36a5e           1185,959            1603,993            1643,1231

  
  27.#e3e3e3           1357,875            1420,1023          1357,1023
  28.#949494           1384,806            1392,954            1357,875
  29.#e3e3e3            1362,746            1419,713            1357,875
  30.#484848           1391,691            1467,681            1362,746
  `),
  dragPiece: {
    index: 5,
    x: window.innerWidth / 750 * 10,
    y: window.innerWidth / 750 * 430
  },
  animate: [{
    // 状态1
    pieces: [
      {index: 6, piece: formateData('8.#272727            654,1033            792,1282             512,1272')[0]},
      {index: 7, piece: formateData('9.#434343           512,1272            792,1282             651,1516')[0]},
      {index: 8, piece: formateData('10.#4b4b4b          792,1282            929,1518             651,1516')[0]},
      {index: 9, piece: formateData('11.#313131         792,1282            1069,1280           929,1518')[0]},
      {index: 10, piece: formateData('12.#4b4b4b          934,1032           1069,1280           792,1282')[0]},
      {index: 11, piece: formateData('13.#313131          652,1033            934,1032            792,1282')[0]},

      {index: 12, piece: formateData('17.#404040          1325,1161          1430,1343          1222,1335')[0]},
      {index: 13, piece: formateData('18.#343434          1222,1335          1430,1343          1321,1515')[0]},
      {index: 14, piece: formateData('19.#434343          1430,1343          1527,1519          1321,1515')[0]},
      {index: 15, piece: formateData('20.#313131         1430,1343           1633,1343          1527,1518')[0]},
      {index: 16, piece: formateData('21.#4b4b4b          1530,1167          1633,1343          1430,1343')[0]},
      {index: 17, piece: formateData('22.#272727          1325,1161          1530,1167          1430,1343')[0]},

      {index: 29, piece: formateData('30.#484848           1378,686            1449,657            1362,746')[0]}
    ],
    delay: 0,
    duration: 1000
  }, {
    // 状态2
    pieces: [
      {index: 6, piece: formateData('8.#313131            654,1033            792,1282             512,1272')[0]},
      {index: 7, piece: formateData('9.#272727           512,1272            792,1282             651,1516')[0]},
      {index: 8, piece: formateData('10.#434343          792,1282            929,1518             651,1516')[0]},
      {index: 9, piece: formateData('11.#4b4b4b         792,1282            1069,1280           929,1518')[0]},
      {index: 10, piece: formateData('12.#313131          934,1032           1069,1280           792,1282')[0]},
      {index: 11, piece: formateData('13.#4b4b4b          652,1033            934,1032            792,1282')[0]},

      {index: 12, piece: formateData('17.#272727          1325,1161          1430,1343          1222,1335')[0]},
      {index: 13, piece: formateData('18.#404040          1222,1335          1430,1343          1321,1515')[0]},
      {index: 14, piece: formateData('19.#343434          1430,1343          1527,1519          1321,1515')[0]},
      {index: 15, piece: formateData('20.#434343         1430,1343           1633,1343          1527,1518')[0]},
      {index: 16, piece: formateData('21.#313131          1530,1167          1633,1343          1430,1343')[0]},
      {index: 17, piece: formateData('22.#4b4b4b          1325,1161          1530,1167          1430,1343')[0]},

      {index: 29, piece: formateData('30.#484848           1391,691            1467,681            1362,746')[0]}
    ],
    delay: 0,
    duration: 1000
  }, {
    // 状态3
    pieces: [
      {index: 6, piece: formateData('8.#4b4b4b            654,1033            792,1282             512,1272')[0]},
      {index: 7, piece: formateData('9.#313131           512,1272            792,1282             651,1516')[0]},
      {index: 8, piece: formateData('10.#272727          792,1282            929,1518             651,1516')[0]},
      {index: 9, piece: formateData('11.#434343         792,1282            1069,1280           929,1518')[0]},
      {index: 10, piece: formateData('12.#4b4b4b          934,1032           1069,1280           792,1282')[0]},
      {index: 11, piece: formateData('13.#313131          652,1033            934,1032            792,1282')[0]},

      {index: 12, piece: formateData('17.#4b4b4b          1325,1161          1430,1343          1222,1335')[0]},
      {index: 13, piece: formateData('18.#272727          1222,1335          1430,1343          1321,1515')[0]},
      {index: 14, piece: formateData('19.#404040          1430,1343          1527,1519          1321,1515')[0]},
      {index: 15, piece: formateData('20.#343434         1430,1343           1633,1343          1527,1518')[0]},
      {index: 16, piece: formateData('21.#434343          1530,1167          1633,1343          1430,1343')[0]},
      {index: 17, piece: formateData('22.#313131          1325,1161          1530,1167          1430,1343')[0]},

      {index: 29, piece: formateData('30.#484848           1378,686            1449,657            1362,746')[0]}
    ],
    delay: 0,
    duration: 1000
  }, {
    // 状态4
    pieces: [
      {index: 6, piece: formateData('8.#313131            654,1033            792,1282             512,1272')[0]},
      {index: 7, piece: formateData('9.#4b4b4b           512,1272            792,1282             651,1516')[0]},
      {index: 8, piece: formateData('10.#313131          792,1282            929,1518             651,1516')[0]},
      {index: 9, piece: formateData('11.#272727         792,1282            1069,1280           929,1518')[0]},
      {index: 10, piece: formateData('12.#434343          934,1032           1069,1280           792,1282')[0]},
      {index: 11, piece: formateData('13.#4b4b4b          652,1033            934,1032            792,1282')[0]},

      {index: 12, piece: formateData('17.#4b4b4b          1325,1161          1430,1343          1222,1335')[0]},
      {index: 13, piece: formateData('18.#272727          1222,1335          1430,1343          1321,1515')[0]},
      {index: 14, piece: formateData('19.#404040          1430,1343          1527,1519          1321,1515')[0]},
      {index: 15, piece: formateData('20.#343434         1430,1343           1633,1343          1527,1518')[0]},
      {index: 16, piece: formateData('21.#434343          1530,1167          1633,1343          1430,1343')[0]},
      {index: 17, piece: formateData('22.#313131          1325,1161          1530,1167          1430,1343')[0]},

      {index: 29, piece: formateData('30.#484848           1391,691            1467,681            1362,746')[0]}
    ],
    delay: 0,
    duration: 1000
  }]
}


// 文化，脸谱
const face = {
  bg: 'bg_culture',
  keyword: '文化生活',
  quotoText: '发展社会主义先进文化，提升国家文化软实力\n提高社会文明程度\n把提高质量作为文艺作品的生命线，提高文艺原创能力\n加强对外文化交流和多层次文明对话\n深入发展大众旅游、智慧旅游'.split('\n'),
  head: 'culture.png',
  title: '全国人大代表 齐玫',
  title2: '全国人大代表、首都博物馆首席研究馆员 齐玫',
  desc: '文化强国的根基是中华优秀传统文化',
  audio: 'culture.mp3',
  text: '2035年建成文化强国。文化强国的根基就是中国优秀的传统文化。中国特色社会主义文化也源于中华优秀的传统文化。\n中华优秀的传统文化，体现出中国人特有的思维方式和精神标志，它为实现社会主义现代化建设提供了精神滋养和智慧力量。在全民的宣传教育中应该大力弘扬优秀的传统文化，使它发扬光大，成为中国人引以自豪的根本。在文化强国的发展进程中，作为强劲的动力和源泉，牢固的基础和根基。\n博物馆作为优秀传统文化的重要阵地，特别是馆藏文物蕴含了优秀传统文化的深厚底蕴，所以要重视博物馆在“大力弘扬优秀传统文化”中的重要作用，使文物与社会共享。'.split('\n'),
  pieces: formateData(`
  28.#ffefef         902,585         1285,587        1091,1130
  29.#ffefef         718,975         1462,975        1092,1236
  30.#ffefef         875,1325       1305,1325     1090,1574
  1.#282828      902,585      1037,975       740,722
  2.#ffefef          740,722      1037,975       715,888
  3.#282828      715,888      1037,975       1028,1065
  5.#313131      715,888      1028,1065      772,1092
  4.#ffffff           812,943       951,1023      853,1026
  6.#a33433      715,888       772,1092       741,1254
  9.#ea5d6a      1028,1065    1072,1219     772,1092
  8.#df4456       772,1092     980,1180       877,1390
  7.#c03c4a       772,1092     924,1515       741,1254
  11.#282828    987,1167      1092,1236     943,1403
  10.#313131    987,1167      924,1515       877,1390
  16.#ffe7ea      943,1403      1090,1574      924,1515
  27.#ea5d6a      1090,699      1147,975        1037,975
  12.#282828    1092,1236    1170,1325     1012,1325
  15.#ea5d6a    1026,1325     1155,1325     1090,1353
  26.#282828      1285,587      1441,723        1147,975
  25.#ffefef         1441,723      1468,891        1147,975
  24.#282828     1468,891      1156,1064      1147,975
  22.#313131     1468,891      1412,1095      1156,1064 
  23.#ffffff          1372,943      1325,1027      1233,1022
  20.#ea5d6a     1156,1064     1412,1095     1112,1219
  17.#ffe7ea      1237,1403     1258,1515     1090,1574
  19.#df4456     1412,1095     1304,1389     1198,1179
  18.#c03c4a     1412,1095     1440,1256     1258,1515
  13.#282828    1092,1236    1193,1169     1237,1403
  14.#313131    1193,1169    1304,1389     1258,1515
  21.#a33433     1468,891      1440,1256      1412,1095
  `),
  dragPiece: {
    index: 0,
    x: window.innerWidth / 750 * 10,
    y: window.innerWidth / 750 * 450
  },
  animate: [{
    pieces: [
      {index: 12, piece: formateData('11.#282828    987,1148      1092,1236     943,1403')[0]},
      {index: 13, piece: formateData('10.#313131    987,1148      924,1515       877,1390')[0]},
      {index: 27, piece: formateData('13.#282828    1092,1236    1193,1148     1237,1403')[0]},
      {index: 28, piece: formateData('14.#313131    1193,1148    1304,1389     1258,1515')[0]},
      
      {index: 3, piece: formateData('1.#282828      902,585      1037,956       740,722')[0]},
      {index: 4, piece: formateData('2.#ffefef          740,722      1037,956       715,888')[0]},
      {index: 5, piece: formateData('3.#282828      715,888      1037,956       1028,1065')[0]},
      {index: 15, piece: formateData('27.#ea5d6a      1090,699      1147,956        1037,956')[0]},
      {index: 18, piece: formateData('26.#282828      1285,587      1441,723        1147,956')[0]},
      {index: 19, piece: formateData('25.#ffefef         1441,723      1468,891        1147,956')[0]},
      {index: 20, piece: formateData('24.#282828     1468,891      1156,1064      1147,956')[0]}
    ],
    delay: 0,
    duration: 500
  }, {
    pieces: [
      // 11,10,13,14
      {index: 12, piece: formateData('11.#282828    987,1167      1092,1236     943,1403')[0]},
      {index: 13, piece: formateData('10.#313131    987,1167      924,1515       877,1390')[0]},
      {index: 27, piece: formateData('13.#282828    1092,1236    1193,1169     1237,1403')[0]},
      {index: 28, piece: formateData('14.#313131    1193,1169    1304,1389     1258,1515')[0]},
      // 1,2,3,27,26,25,24
      // 956
      {index: 3, piece: formateData('1.#282828      902,585      1037,975       740,722')[0]},
      {index: 4, piece: formateData('2.#ffefef          740,722      1037,975       715,888')[0]},
      {index: 5, piece: formateData('3.#282828      715,888      1037,975       1028,1065')[0]},
      {index: 15, piece: formateData('27.#ea5d6a      1090,699      1147,975        1037,975')[0]},
      {index: 18, piece: formateData('26.#282828      1285,587      1441,723        1147,975')[0]},
      {index: 19, piece: formateData('25.#ffefef         1441,723      1468,891        1147,975')[0]},
      {index: 20, piece: formateData('24.#282828     1468,891      1156,1064      1147,975')[0]}
    ],
    delay: 0,
    duration: 500
  }, {
    pieces: [
      // 11,10,13,14
      {index: 12, piece: formateData('#282828    987,1148      1092,1236     943,1403')[0]},
      {index: 13, piece: formateData('#313131    987,1148      924,1515       877,1390')[0]},
      {index: 27, piece: formateData('#282828    1092,1236    1193,1148     1237,1403')[0]},
      {index: 28, piece: formateData('#313131    1193,1148    1304,1389     1258,1515')[0]},
      // 1,2,3,27,26,25,24
      // 956
      {index: 3, piece: formateData('#282828      902,585      1037,956       740,722')[0]},
      {index: 4, piece: formateData('#ffefef          740,722      1037,956       715,888')[0]},
      {index: 5, piece: formateData('#282828      715,888      1037,956       1028,1065')[0]},
      {index: 15, piece: formateData('#ea5d6a      1090,699      1147,956        1037,956')[0]},
      {index: 18, piece: formateData('#282828      1285,587      1441,723        1147,956')[0]},
      {index: 19, piece: formateData('#ffefef         1441,723      1468,891        1147,956')[0]},
      {index: 20, piece: formateData('#282828     1468,891      1156,1064      1147,956')[0]}
    ],
    delay: 0,
    duration: 500
  }, {
    pieces: [
      // 11,10,13,14
      {index: 12, piece: formateData('11.#282828    987,1167      1092,1236     943,1403')[0]},
      {index: 13, piece: formateData('10.#313131    987,1167      924,1515       877,1390')[0]},
      {index: 27, piece: formateData('13.#282828    1092,1236    1193,1169     1237,1403')[0]},
      {index: 28, piece: formateData('14.#313131    1193,1169    1304,1389     1258,1515')[0]},
      // 1,2,3,27,26,25,24
      // 956
      {index: 3, piece: formateData('1.#282828      902,585      1037,975       740,722')[0]},
      {index: 4, piece: formateData('2.#ffefef          740,722      1037,975       715,888')[0]},
      {index: 5, piece: formateData('3.#282828      715,888      1037,975       1028,1065')[0]},
      {index: 15, piece: formateData('27.#ea5d6a      1090,699      1147,975        1037,975')[0]},
      {index: 18, piece: formateData('26.#282828      1285,587      1441,723        1147,975')[0]},
      {index: 19, piece: formateData('25.#ffefef         1441,723      1468,891        1147,975')[0]},
      {index: 20, piece: formateData('24.#282828     1468,891      1156,1064      1147,975')[0]}
    ],
    delay: 0,
    duration: 500
  }, {
    pieces: [],
    delay: 3000,
    duration: 0
  }]
}


// 绿色发展,环境保护,生态
const tree = {
  bg: 'bg_ecology',
  keyword: '绿色发展',
  quotoText: '坚持绿水青山就是金山银山理念\n湿地保护率提高到55%\n地级及以上城市PM2.5浓度下降10%\n单位国内生产总值能源消耗和二氧化碳排放分别降低13.5%、18%\n森林覆盖率提高到24.1%'.split('\n'),
  head: 'environment.jpg',
  audio: 'environment.mp3',
  title: '全国人大代表 杨晓雪',
  title2: '全国人大代表、云南省大理州环境监测站副总工程师 杨晓雪',
  desc: '湖泊保护不是一蹴而就的事，需要一个很长的阶段',
  text: '湖泊保护不是一蹴而就的事情，需要一个很长的阶段，我们现在只是把它下滑的趋势遏制住。今年我关注的是长江保护。总书记也说了，长江要“共抓大保护，不搞大开发”。因为长江干流自西向东经过十一个省，云南也在其中，且处于长江的上游地区，经济欠发达，基础设施比较落后，农村的生活污水、生活垃圾的收集和处理有很大缺陷，不能得到有效的治理就排放，水质就受到影响。所以，如果长江上段的保护工作做不好的话，下段的工作就更困难。希望国家能够关注、支持我们做好农村生活污水、生活垃圾的收集和治理工作。'.split('\n'),
  pieces: formateData(`
  30.#271b0b          1070,1384         1064,1556         1007,1571
  29.#332511          1070,1384         1218,1571         1064,1556
  28.#664b23          1132,1362         1218,1571         1070,1384
  23.#4b3a1e          972,1250           1082,1348         1055,1427
  24.#332511          971,1111           1097,1308         1070,1384
  27.#271b0b          1131,1305         1132,1362         1070,1384
  26.#664b23          1192,1238         1132,1362         1131,1305
  25.#684717          1143,1170         1131,1305         1070,1384
  
  19.#364d0b          632,1117           971,1111          759,1279
  20.#262f00           971,1111           924,1303          780,1261
  21.#465606          971,1111           1080,1221         924,1303
  22.#262f00           971,1111           1316,1270        1080,1221
  17.#739a29          1363,989           1119,1179         971,1111
  16.#496416          1363,989           1316,1270        1119,1179
  6.#cceb53            696,792              854,730            632,1117
  7.#749c29            854,730             971,1111          632,1117
  8.#465606           854,730              1000,875            971,1111
  18.#5f811f            1000,875            1176,1047         971,1111
  9.#cfea64             1100,582           1176,1047        854,730 
  10.#79a428          1100,582           1392,835          1176,1047
  15.#364d0b          1390,835           1363,989          1176,1047
  14.#92b52e          1390,835           1500,1169        1323,1231
  13.#739a29          1390,835           1527,891          1463,1053
  11.#496416          1219,684           1358,681          1390,835
  12.#cceb53           1358,681          1500,879           1390,835

  3.#fcd46a             840,622             800,725            622,706
  2.#eb847f             680,641             777,644            714,670
  1.#d75f5a             705,601             807,663            723,694
  4.#f6c137             835,635             872,668            818,682
  5.#4b5050            859,656             875,673            858,673
  `),
  dragPiece: {
    index: 1,
    x: window.innerWidth / 750 * 0,
    y: window.innerWidth / 750 * 220
  },
  animate: [{
    pieces: [
      {index: 26, piece: formateData('2.#eb847f             705,662             777,644            714,670')[0]},
      {index: 27, piece: formateData('1.#d75f5a             716,654             807,663            723,694')[0]}
    ],
    delay: 0,
    duration: 1500
  }, {
    pieces: [
      {index: 26, piece: formateData('2.#eb847f             680,641             777,644            714,670')[0]},
      {index: 27, piece: formateData('1.#d75f5a             705,601             807,663            723,694')[0]}
    ],
    delay: 0,
    duration: 1500
  }, {
    pieces: [],
    delay: 2000,
    duration: 0
  }]
}


// 教育 帽子
const education = {
  bg: 'bg_education',
  keyword: '教育',
  quotoText: '建设高质量教育体系\n实施教育提质扩容工程\n劳动年龄人口平均受教育年限提高到11.3年\n高中阶段教育毛入学率提高到92%以上，学前教育毛入园率提高到90%以上，高等教育毛入学率提高到60%'.split('\n'),
  head: 'education.jpg',
  audio: 'education.mp3',
  title: '全国人大代表 周洪宇',
  title2: '全国人大代表、湖北省人大常委会副主任、华中师范大学教授 周洪宇',
  desc: '营造协同育人的新环境，要建设好学校、家庭、社会、政府四个阵地',
  text: '营造协同育人的新环境，要建设好学校、家庭、社会、政府四个阵地，营造全方位、立体化、协调一致的育人新环境。\n要做到全社会形成教育合力，首先要强调家庭的教育责任。家庭是社会的基本细胞，是人生的第一所学校，家庭教育涉及到很多方面，但最重要的是品德教育，是如何做人的教育。\n家庭以外，还要发挥学校在学生成长当中的主渠道作用。认真履行教书育人的职责，积极与家长进行沟通交流，传递科学教育理念，引导家长配合教师完成教学任务。\n从社会角度来说，要积极开放利用社会资源，特别是要用好博物馆、图书馆、科技馆、少年宫、展览馆、红色教育基地等等，强化实践育人，发挥社会大课堂的育人作用。\n从政府角度来看，要切实履行政府的保障作用，要加强统筹规划与条件保障，要健全教育、发改、工信、光电等部门共同参与和支持教育教学的工作机制，担起协同育人中政府应该尽的责任。'.split('\n'),
  pieces: formateData(`
  17 #242424 855,705 1183,749 240,900
  16 #3E3E41 780,813 1084,1015 240,900
  13 #3E3E41 627,1023 856,1412 627,1211
  14 #0D0D0D 627,1023 881,1103 722,1185
  12 #272727 881,1103 856,1412 722,1185
  1 #141414 1088,632 1183,749 855,705
  18 #1F1F1F 1183,749 1084,1015 780,813
  10 #0D0D0D 881,1103 1089,1170 1296,1423
  11 #3E3E41 881,1103 1296,1423 856,1412
  9 #0D0D0D 1273,1110 1296,1423 1089,1170
  15 #2B2B2B 240,900 1437,1057 1089,1170
  2 #3E3E41 1088,632 1485,760 1248,832
  22 #141414 1183,749 1437,1057 1084,1015
  3 #2B2B2B 1485,760 1437,1057 1248,832
  6 #0D0D0D 1524,1028 1429,1197 1273,1110
  8 #272727 1273,1110 1429,1197 1296,1423
  7 #3E3E41 1524,1028 1524,1223 1296,1423
  4 #3E3E41 1485,760 1917,900 1459,920
  5 #474747 1459,920 1917,900 1437,1057
  19 #F59909 1144,850 1120,913 1083,863
  21 #F3D758 1136,871 1568,1019 1128,891
  20 #FABF12 1140,860 1162,892 1123,903
  23 #F59909 1257,928 1569,1014 1545,1022
  24 #F59909 1569,1014 1566,1279 1545,1022
  25 #F3D758 1557,1173 1570,1325 1557,1326
  26 #FABF12 1587,1319 1587,1338 1541,1329
  27 #F59909 1541,1329 1587,1338 1541,1346
  28 #FABF12 1580,1339 1501,1502 1547,1345
  29 #F3D758 1580,1339 1576,1523 1544,1415
  30 #F59909 1580,1339 1635,1478 1578,1438
  `),
  dragPiece: {
    index: 8,
    x: window.innerWidth / 750 * 20,
    y: window.innerWidth / 750 * 300
  },
  animate: [{
    pieces: [
      {index: 23, piece: formateData('24 #F59909 1569,1014 1552,1260 1545,1022')[0]},
      {index: 24, piece: formateData('25 #F3D758 1552,1182 1552,1323 1538,1326')[0]},
      {index: 25, piece: formateData('26 #FABF12 1569,1320 1569,1338 1522,1330')[0]},
      {index: 26, piece: formateData('27 #F59909 1522,1330 1569,1338 1522,1348')[0]},
      {index: 27, piece: formateData('28 #FABF12 1562,1340 1452,1503 1528,1346')[0]},
      {index: 28, piece: formateData('29 #F3D758 1562,1340 1517,1525 1508,1416')[0]},
      {index: 29, piece: formateData('30 #F59909 1562,1340 1576,1478 1539,1438')[0]}
    ],
    delay: 300,
    duration: 700
  }, {
    pieces: [
      {index: 23, piece: formateData('24 #F59909 1569,1014 1571,1279 1545,1022')[0]},
      {index: 24, piece: formateData('25 #F3D758 1572,1173 1591,1325 1576,1326')[0]},

      {index: 25, piece: formateData('26 #FABF12 1607,1319 1607,1338 1561,1329')[0]},
      {index: 26, piece: formateData('27 #F59909 1561,1329 1607,1338 1561,1346')[0]},

      {index: 27, piece: formateData('28 #FABF12 1603,1339 1570,1502 1569,1345')[0]},
      {index: 28, piece: formateData('29 #F3D758 1603,1339 1638,1523 1587,1415')[0]},
      {index: 29, piece: formateData('30 #F59909 1603,1339 1697,1478 1621,1438')[0]}
    ],
    delay: 0,
    duration: 1000
  }, {
    pieces: [
      {index: 23, piece: formateData('24 #F59909 1569,1014 1566,1279 1545,1022')[0]},
      {index: 24, piece: formateData('25 #F3D758 1557,1173 1570,1325 1557,1326')[0]},
      {index: 25, piece: formateData('26 #FABF12 1587,1319 1587,1338 1541,1329')[0]},
      {index: 26, piece: formateData('27 #F59909 1541,1329 1587,1338 1541,1346')[0]},
      {index: 27, piece: formateData('28 #FABF12 1580,1339 1501,1502 1547,1345')[0]},
      {index: 28, piece: formateData('29 #F3D758 1580,1339 1576,1523 1544,1415')[0]},
      {index: 29, piece: formateData('30 #F59909 1580,1339 1635,1478 1578,1438')[0]}
    ],
    delay: 0,
    duration: 700
  }, {
    pieces: [],
    delay: 2000,
    duration: 0
  }]
}


// 健康，医疗
const medical = {
  bg: 'bg_medical',
  keyword: '健康中国',
  quotoText: '全面推进健康中国建设，人均预期寿命提高1岁\n构建强大公共卫生体系\n健全全民医保制度\n大力发展中医药事业\n广泛开展全民健身运动，新建、改扩建1000个左右体育公园'.split('\n'),
  head: 'medical.jpg',
  audio: 'medical.mp3',
  title: '全国人大代表 张伯礼',
  title2: '全国人大代表、中国工程院院士 张伯礼',
  desc: '健康中国是民族昌盛、国家富强的重要标志',
  text: '健康中国是民族昌盛、国家富强的重要标志；也是人民群众共同追求美好生活的一个目标。没有全民的健康，就没有全面的小康。随着人民生活水平的日益提高，人们对健康的要求也越来越高。健康中国的建设不单单是政府的事，也是我们老百姓自己的事。\n我们要加强健康素养的教育，同时要有健康的生活方式。居民的健康素养水平提升了，健康中国建设才有好的基础，追求健康的社会氛围才能够真正形成。\n健康中国关乎到每个人，每个人又是主力军，又是参与者：医生努力治，我们努力不得病、少得病、晚得病，同时发挥中西并重的优势，大家共同努力。\n中国有中医药、西医药共同发挥作用，是我们中国的优势，是我们中国人民的福气，应该充分发挥两者的作用。中西医结合不单是抗击疫情的成功经验，也是今后在健康中国建设、在重大疾病治疗中的成功法宝。'.split('\n'),
  pieces: formateData(`
  5 #E9F0FF 1010,627 1649,780 499,756
  6 #F8FAFF 1649,780 1145,945 499,756
  21 #2C2C2C 886,603 960,704 886,727
  22 #000000 938,590 960,704 886,603
  1 #4D4D4D 938,590 1160,662 886,603
  2 #3D3D3D 938,590 1219,647 1160,662
  3 #1E1E1E 1160,662 1219,647 1244,787
  4 #000000 1160,662 1244,787 1154,816

  19 #DDE8FF 503,872 1145,945 1145,1088
  20 #E4EDFF 499,756 1145,945 503,872
  7 #D8E5FF 1649,780 1649,928 1145,945
  8 #D8E5FF 1145,945 1649,928 1145,1088
  9 #D0E0FF 1145,1088 1635,932 1145,1563
  10 #C4D8FF 1635,932 1635,1344 1145,1563
  11 #EDF4FE 1145,1088 1145,1563 533,1284
  12 #F8FAFF 518,877 1145,1088 533,1284

  13 #D54D4D 905,1184 905,1290 819,1247
  14 #A32526 820,1155 905,1184 819,1247
  15 #A32626 822,1051 818,1343 745,1312
  16 #D54D4D 744,1027  822,1051 745,1312
  17 #A32626 744,1126 744,1222 685,1197
  18 #D54D4D 681,1103 744,1126 685,1197
  
  23 #02B98D 911,1478 915,1541 831,1557
  24 #00B17D 911,1478 831,1557 807,1477
  25 #EEF2F3 807,1477 831,1557 727,1554
  26 #FAFCFB 807,1477 727,1554 723,1492
  27 #EEF2F3 824,1408 849,1464 775,1508
  28 #FAFCFB 824,1408 775,1508 725,1441
  29 #014E9E 725,1441 775,1508 677,1540
  30 #0097DC 725,1441 677,1540 652,1484
  `),
  dragPiece: {
    index: 19,
    x: window.innerWidth / 750 * 110,
    y: window.innerWidth / 750 * 350
  },
  animate: []
}


// 养老
const oldage = {
  bg: 'bg_pension',
  keyword: '养老',
  quotoText: '实施积极应对人口老龄化国家战略\n以“一老一小”为重点完善人口服务体系\n构建居家社区机构相协调、医养康养相结合的养老服务体系\n强化对失能、部分失能特困老年人的兜底保障\n基本养老保险参保率提高到95%'.split('\n'),
  head: 'oldman.jpg',
  audio: 'oldman.mp3',
  title: '全国政协委员 孙昌隆',
  title2: '全国政协委员、天津市南开区政协副主席 孙昌隆',
  desc: '探索智慧养老新模式，推动普惠性养老服务进社区',
  text: '建议利用大数据、云计算为代表的数据处理技术深入挖掘老年人服务需求，建立养老服务需求信息资料库，为政府购买服务的对象确定、费用补贴、服务项目确定等提供依据。二是依托手机APP平台和PC端，为养老服务供求信息提供交互的平台，内联辖区内有实际服务需求的老人，外联社区养老服务中心、服务商和加盟企业。信息交互平台利用互联网、射频识别技术，将记录、统计及监控到的需求信息集中汇总并分别传输给为老服务团队，由其提供上门服务，促使养老服务供需有效对接、资源有效匹配。\n可以将社区养老服务所需的照看护理、家政服务、医疗保健、社会工作、精神慰藉等资源整合起来，形成社区养老服务集成系统。利用互联网链接政府、社会组织、企业和志愿者等多类型主体，吸引多种社会资源参与为老服务。'.split('\n'),
  pieces: formateData(`
  1.#777777               962,583             1078,606             935,645
  2.#c6c6c6                1078,606           1171,713             935,645
  3.#ffe4cd                 935,645             1130,702             1053,807
  4.#eabf9b                935,645             1053,807             918,845
  5.#bdd3cf               885,722              983,831              929,1035
  6.#a7c5bf                885,722              929,1035            730,809
  7.#91b8b1              730,809              929,1035            898,1409
  8.#bdd3cf               730,809              898,1409            606,939
  11.#7091a1             632,1295           666,1518             581,1496
  12.#7091a1             739,1292           838,1501             741,1501
  9.#a7c5bf                606,939              898,1409            514,1170
  10.#91b8b1            514,1170            898,1409            513,1364
  13.#4e7081             592,1453           687,1523             581,1496
  14.#4e7081             740,1456           860,1501             741,1501
  15.#cce5e1             983,831             1024,1012           929,1035
  16.#91b8b1            1024,1012         1090,1129           929,1035
  18.#37444d            1085,1107         1439,1275           1415,1303
  17.#cce5e1             1024,1012         1143,1099           1090,1129
  19.#f87e3d             1478,1230         1665,1280           1647,1351
  20.#ff9e6a              1484,1174         1511,1237           1478,1230
  21.#c46c3d             1478,1230         1647,1351           1510,1375
  22.#ff9e6a              1478,1230         1510,1375            1415,1303
  23.#f87e3d             1415,1303         1411,1422            1248,1326     
  24.#f87e3d             1415,1303         1510,1375            1404,1539
  25.#af5c30              1492,1403         1500,1505            1445,1476
  26.#af5c30              1248,1326         1401,1416            1233,1480
  27.#f87e3d             1248,1326         1227,1544            1133,1373
  28.#af5c30              1149,1345         1248,1326           1133,1373
  29.#f87e3d             1081,1330         1149,1345            1133,1373
  30.#c46c3d             1133,1373         1235,1559            1116,1559
  `),
  dragPiece: {
    index: 16,
    x: window.innerWidth / 750 * (-50),
    y: window.innerWidth / 750 * 330
  },
  animate: [{
    pieces: [
      {index: 18, piece: formateData('19.#f87e3d             1478,1230         1661,1279           1647,1351')[0]},
      {index: 28, piece: formateData('29.#f87e3d             1078,1350         1149,1345            1133,1373')[0]},
    ],
    delay: 0,
    duration: 1000
  }, {
    pieces: [
      {index: 18, piece: formateData('19.#f87e3d             1478,1230         1655,1279           1647,1351')[0]},
      {index: 28, piece: formateData('29.#f87e3d             1099,1315         1149,1345            1133,1373')[0]},
    ],
    delay: 0,
    duration: 1000
  }, {
    pieces: [],
    delay: 2000,
    duration: 0
  }]
}


// 就业，证件
const card = {
  bg: 'bg_job',
  keyword: '就业',
  quotoText: '城镇调查失业率控制在5.5％以内\n实施就业优先战略，扩大就业容量\n完善高校毕业生、农民工、退役军人等重点群体就业支持体系\n促进平等就业，增加高质量就业'.split('\n'),
  head: 'jobs.jpg',
  audio: 'jobs.mp3',
  title: '全国人大代表 华茜',
  title2: '全国人大代表、贵州省铜仁市万山区万山镇电商服务中心负责人 华茜',
  desc: '创业不分行业，守得住寂寞，才会有更好的未来',
  text: '我们从事电商行业，唯一不变的是坚持以市场为导向的原则。不管是直播平台还是我们自身，只能以市场为导向、以客户的需求为准则，来做事情。\n国家对直播带货的政策支持，很重要的一方面是政府认可这个行业，在大环境中起到了一个宣传推广的作用。所以在大环境比较好的情况下，我们这些互联网人在推动农村电商促就业的工作中，就能为大家谋到很多福利。这两年乡村变化很大。随着异地搬迁扶贫政策的启动，很多搬进城的贫困户选择就近在当地就业，就业问题很大程度上得以解决，大家在城镇里就能务工，不需要像以前那样过完年就要出去。\n互联网销售，服务理念和服务意识这方面是需要一点一点积累的，很难马上培养。从产品品质到后续服务，再到像二次销售等等的整个产业端，都要去做延伸。把人才留下来，只是一个人、一伙人肯定是不够的，所以会衍生很多人才出来。通过互联网，不光是我们在改变，农村也在改变。\n创业不分行业，大家切忌浮躁，守得住寂寞，才会有更好的未来。'.split('\n'),
  pieces: formateData(`
  8.#f5f5f5          567,825          1596,825         1432,944
  1.#ffb498         853,632          833,669           822,640
  2.#dd513d       878,587          956,587           833,669
  3.#fa703b        956,587          1093,658         877,640
  4.#dd513d       988,648         1093,658         1137,775
  5.#fa703b        1028,682        1137,776         1025,776
  6.#b23301       1016,776        1145,776         993,874
  7.#681205       1145,776        1169,874         993,874
  15.#fafafa         567,825          1432,944        567,1576
  9.#d0d0d0      1596,825         1596,1576       729,1456
  14.#c4c4c4       729,1456        1596,1576      567,1576
  25.#fce9d8       817,978          995,966          928,1105
  23.#eabf9b      817,978           968,1150        840,1150
  24.#eacaae       995,966          968,1150        928,1105
  28.#4e2507      882,946          995,966          817,978
  27.#4e2507      995,966          996,1011        916,996
  26.#623310      817,978          995,966          799,1040
  20.#f7f7f7        822,1150         987,1150        904,1495
  22.#fa703b      871,1149         938,1149        904,1198
  21.#fa703b      904,1198         961,1495        844,1495
  29.#1d1d1d     822,1150        816,1196        708,1208
  16.#262626      708,1208        815,1196        767,1495
  17.#0f0f0f        822,1150         904,1495        767,1495
  18.#0f0f0f        987,1150         1041,1495      904,1495
  19.#262626      994,1196        1100,1208      1041,1495
  30.#1d1d1d     987,1150        1100,1208      994,1196
  10.#b4b4b4     1239,1133       1425,1139      1425,1170
  11.#c4c4c4      1239,1133       1425,1170      1239,1177
  12.#b4b4b4     1239,1262      1425,1270      1239,1307
  13.#c4c4c4       1425,1270      1425,1301      1239,1307
  `),
  dragPiece: {
    index: 6,
    x: window.innerWidth / 750 * 25,
    y: window.innerWidth / 750 * 450
  },
  animate: [{
    pieces: [
      {index: 16, piece: formateData('26.#623310      817,978          995,966          800,1058')[0]}
    ],
    delay: 500,
    duration: 500
  }, {
    pieces: [
      {index: 16, piece: formateData('26.#623310      817,978          995,966          799,1040')[0]}
    ],
    delay: 500,
    duration: 500
  }, {
    pieces: [],
    delay: 2000,
    duration: 0
  }]
}


// 住房
// const house = {
//   bg: 'bg_housing',
//   keyword: '住房',
//   quotoText: '健全基本养老、基本医疗保险筹资和待遇机制调整；\n健全基本养老、基本医疗保险筹资和待遇机制调整；\n健全基本养老、基本医疗保险筹资和待遇机制调整；\n健全基本养老、基本医疗保险筹资和待遇机制调整；',
//   head: '4.jpg',
//   audio: '2.mp3',
//   title: '全国人大代表 陈静瑜',
//   desc: '将“‘一生饮奶计划’纳入国家重要战略”，终生饮奶“不断奶”',
//   text: '将“‘一生饮奶计划’纳入国家重要战略”，终生饮奶“不断奶”将“‘一生饮奶计划’纳入国家重要战略”，终生饮奶“不断奶”将“‘一生饮奶计划’纳入国家重要战略”，终生饮奶“不断奶”',
//   pieces: formateData(`
//     23 #FFFFFF 534,1080 534,1501 1026,1501
//     28 #5CB67D 534,1341 628,1501 534,1501
//     30 #307456 534,1281 534,1501 403,1501
//     29 #378865 534,1405 534,1501 476,1501
//     22 #ECECEC 1026,1104 1026,1501 561,1104
//     24 #B3DFF4 616,1159 730,1159 616,1281
//     25 #92C5DD 730,1159 730,1281 616,1281
//     26 #92C5DD 829,1159 943,1159 829,1281
//     27 #476E82 943,1159 943,1281 829,1281
//     3 #E16A6C 595,708 1287,708 478,1104
//     4 #BA4648 1287,708 1026,1104 478,1104
//     1 #FFFDFE 668,637 805,637 668,707
//     2 #EAEAEA 805,637 805,707 668,707
    
//     21 #DADADA 1026,1047 1026,1501 957,1501
//     11 #ECECEC 1026,1046 1705,1046 1026,1501
//     14 #D2CBCB 1705,1046 1705,1501 1026,1501
//     19 #378865 1705,1405 1705,1501 1647,1501
//     20 #6AC48B 1705,1340 1705,1501 1799,1501
//     5 #E16A6C 1365,621 1365,1046 983,1046
//     6 #BA4648 1365,621 1365,1046 1762,1046
//     7 #FF9899 1365,798 1365,900 1256,900
//     8 #CB4F51 1365,798 1365,900 1474,900
//     9 #EB787A 1256,900 1365,900 1365,1001
//     10 #9F3436 1365,900 1474,900 1365,1001

//     12 #ACEBFF 1124,1099 1268,1099 1124,1281
//     13 #80C9E0 1268,1099 1268,1281 1124,1281
//     17 #E5E5E5 1396,1183 1580,1183 1396,1501
//     18 #DCD2D2 1580,1183 1581,1501 1396,1501
//     15 #ACEBFF 1437,1233 1540,1233 1540,1291
//     16 #80C9E0 1437,1233 1540,1291 1437,1291
//   `),
//   dragPiece: {
//     index: 24,
//     x: window.innerWidth / 750 * (-20),
//     y: window.innerWidth / 750 * 340
//   },
//   animate: [{
//     pieces: [
//       {index: 26, piece: formateData('17 #E5E5E5 1413,1220 1580,1183 1413,1539')[0]},
//       {index: 27, piece: formateData('18 #DCD2D2 1580,1183 1581,1501 1413,1539')[0]},
//       {index: 28, piece: formateData('15 #ACEBFF 1450,1262 1545,1241 1545,1300')[0]},
//       {index: 29, piece: formateData('16 #80C9E0 1450,1262 1545,1300 1450,1320')[0]}
//     ],
//     delay: 0,
//     duration: 1500
//   }, {
//     pieces: [
//       {index: 26, piece: formateData('17 #E5E5E5 1396,1183 1580,1183 1396,1501')[0]},
//       {index: 27, piece: formateData('18 #DCD2D2 1580,1183 1581,1501 1396,1501')[0]},
//       {index: 28, piece: formateData('15 #ACEBFF 1437,1233 1540,1233 1540,1291')[0]},
//       {index: 29, piece: formateData('16 #80C9E0 1437,1233 1540,1291 1437,1291')[0]}
//     ],
//     delay: 0,
//     duration: 1500
//   }, {
//     pieces: [],
//     delay: 2000,
//     duration: 0
//   }]
// }



// 吊机，备用
// const diaoji = {
//   pieces: formateData(`
//   25.#321c00              1065,1484            1065,1553             760,1553
//   26.#542f00               760,1484              1065,1484            760,1553
//   27.#7d4701              878,1267              948,1484              878,1484
//   28.#f99413               878,1267              948,1267              948,1484
//   29.#ffaa06                948,1047              948,1267              878,1267
//   30.#d17704              878,1047              948,1047              878,1267
//   8.#f99413                 878,825                947,1047             878,1047
//   9.#d17704               878,825                 947,825               947,1047
//   2.#ffaa06                   947,606               947,825                878,825
//   1.#d17704                 878,606               947,606                878,825
//   4.#542f00                 571,916                880,999               571,999
//   7.#d17704               571,916                 878,916               878,998
//   3.#321c00                 874,737               610,915                571,916

//   10.#ffaa06                947,914                1175,914             947,997
//   11.#7d4701             1175,914              1175,989              947,997
//   12.#321c00              950,736                1111,914             1093,914

//   13.#d17704             1175,914               1400,981             1175,989
//   14.#ffaa06               1175,914               1400,914              1400,981
//   15.#ffd78a               1400,914              1557,914              1400,981
//   17.#d17704             1557,914              1557,934              1400,981
//   16.#321c00              950,736                1557,914              1495,914

//   6.#321c00                571,999              732,999             732,1133
//   5.#542f00                 571,999              732,1133             571,1133
  
//   18.#321c00              1535,941              1549,936              1540,1190
//   20.#321c00              1540,1190            1397,1252            1375,1252
//   19.#321c00              1540,1190            1706,1252            1686,1252
//   21.#d17704             1375,1252             1706,1252            1375,1277
//   22.#764200              1706,1252            1706,1277            1375,1277
//   24.#e68f1f                1375,1284            1706,1284            1375,1305
//   23.#764200              1706,1284            1706,1305            1375,1305
//   `),
// dragPiece: {
//   index: 0,
//   x: window.innerWidth / 750 * 175,
//   y: window.innerWidth / 750 * 400
// },
//   animate: []
// }


// 内容页顺序
export default [defalutPiece, science, i5G, train, shopping, tractor, face, tree, education, medical, oldage, card]
